export class RestoreGoogleWorkspaceUserMailRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreScope",
            "baseName": "restoreScope",
            "type": "GoogleWorkspaceUserMailRestoreScope",
            "format": ""
        },
        {
            "name": "entireMailbox",
            "baseName": "entireMailbox",
            "type": "GoogleWorkspaceUserMailEntireMailboxOptions",
            "format": ""
        },
        {
            "name": "selectedItems",
            "baseName": "selectedItems",
            "type": "GoogleWorkspaceUserMailSelectedItemsOptions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGoogleWorkspaceUserMailRequest.attributeTypeMap;
    }
    constructor() {
    }
}
